module.exports = __webpack_public_path__ + "img/nav02.630b4861.png";